module.exports = __webpack_public_path__ + "img/68400.9afc9f84.jpg";